import React from 'react'
import { Layout, Stack, Main } from '@layout'
import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
import Seo from '@widgets/Seo'
import ContactForm from '@widgets/ContactForm'

const PageContact = props => (
  <Layout {...props}>
    <Seo title='Contato' />
    <Divider />
    <Stack>
      <Main>
        <PageTitle
          header="Precisando de uma consultoria ou ajuda no seu alemão?"
          subheader='Caso precise de ajuda no seu projeto, mande uma mensagem e deixe-me saber mais a respeito.'
        />
        <Divider />
        <ContactForm />
      </Main>
    </Stack>
  </Layout>
)

export default PageContact
